import React, { useState } from 'react';
import { Tooltip, ActionIcon, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { useI18n } from '../../locales/i18n-context';

export const ThemeToggle: React.FC = () => {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const { t } = useI18n();
  const [rotating, setRotating] = useState(false);

  const isDark = colorScheme === 'dark';
  const label = isDark ? t('theme.switchLight') : t('theme.switchDark');

  const handleClick = () => {
    setRotating(true);
    toggleColorScheme();
    setTimeout(() => setRotating(false), 300);
  };

  return (
    <Tooltip label={label} position="bottom">
      <ActionIcon
        variant="subtle"
        onClick={handleClick}
        aria-label={label}
        style={{
          transform: rotating ? 'rotate(360deg)' : 'rotate(0deg)',
          transition: 'transform 300ms ease-in-out',
          color: isDark ? 'var(--cb-text-secondary)' : 'var(--cb-gold)',
        }}
      >
        {isDark ? <IconMoon size={18} /> : <IconSun size={18} />}
      </ActionIcon>
    </Tooltip>
  );
};
